import { useSelector } from 'react-redux';
import { useContext, useRef } from 'react';
import { getUserId } from 'store/user/selectors';
import useActionWithDelay from 'hooks/useActionWithDelay';
import {
  popFront,
  pushFrontKarmaEarnRedirectErrorModal,
  pushFrontKarmaEarnRedirectLoadingModal,
} from 'store/modals/actions';
import useAction from 'hooks/useAction';
import Alooma from 'services/alooma';
import asyncSleep from 'functions/asyncSleep';
import { getKarmaEarnRedirectUrl } from 'functions/karmaEarn';
import CConsole from 'functions/CConsole';

const useGetKarmaEarnRedirect = item => {
  const userId = useSelector(getUserId);
  const closeFunc = useActionWithDelay(popFront);
  const pushFrontKarmaEarnRedirectLoadingModalFunc = useAction(pushFrontKarmaEarnRedirectLoadingModal);
  const pushFrontKarmaEarnRedirectErrorModalFunc = useAction(pushFrontKarmaEarnRedirectErrorModal);
  const aloomaSource = useContext(Alooma.SourceContext);
  const isHandled = useRef(false);

  const redirectFailed = async () => {
    await asyncSleep(10000);

    if (isHandled.current) {
      return;
    }

    closeFunc();
    pushFrontKarmaEarnRedirectErrorModalFunc({ item });
    isHandled.current = true;
  };

  const redirectSuccess = async () => {
    try {
      const url = await getKarmaEarnRedirectUrl(userId, item.id, aloomaSource);

      if (isHandled.current) {
        return;
      }

      if (!url) {
        closeFunc();
        pushFrontKarmaEarnRedirectErrorModalFunc({ item });

        return;
      }

      window.open(url, '_blank');
      setTimeout(closeFunc, 5000);
    } catch (e) {
      CConsole.error('useGetKarmaEarnRedirect.redirectSuccess', e);

      if (isHandled.current) {
        return;
      }

      closeFunc();
      pushFrontKarmaEarnRedirectErrorModalFunc({ item });
    }

    isHandled.current = true;
  };

  const redirect = async () => {
    isHandled.current = false;
    pushFrontKarmaEarnRedirectLoadingModalFunc();
    Promise.race([redirectFailed(), redirectSuccess()]);
  };

  return redirect;
};

export default useGetKarmaEarnRedirect;
